module.exports = __webpack_public_path__ + "static/media/abstract2.277c3c2e.jpg";